import { type SanityGallery } from '@metmuseum/types';
import { sortAndGroupGalleries } from 'helpers/galleries';
import { useTranslations } from 'next-intl';

const DisplayGalleryAndFloor = ({
	galleries,
}: {
	galleries: SanityGallery[];
}) => {
	const t = useTranslations();
	if (!galleries?.length) return <></>;

	const sortedGalleries = sortAndGroupGalleries(galleries);
	const gallery = sortedGalleries[0][0];
	const galleryName = gallery.number
		? t('welcomePage.gallery', { number: gallery.number })
		: gallery.name;
	return (
		<>
			{gallery.floor?.title} · {galleryName}
		</>
	);
};

export default DisplayGalleryAndFloor;
